import { render, staticRenderFns } from "./game-sessions-weekly-calendar.vue?vue&type=template&id=180315e8&"
import script from "./game-sessions-weekly-calendar.vue?vue&type=script&lang=ts&"
export * from "./game-sessions-weekly-calendar.vue?vue&type=script&lang=ts&"
import style0 from "./game-sessions-weekly-calendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports